import '../../styles/index.scss';

import { Assets } from 'pixi.js';
import WebFont from 'webfontloader';

import Preloader from './components/Preloader';
import Scene from './components/Scene';
// import { getFeatures, isAndroid, isIOS, isMobileOrTablet } from './helpers/features';
import { isAndroid, isIOS, isMobileOrTablet } from './helpers/features';
import { initResize } from './helpers/resizer';
// import { playSfx } from './helpers/sounds';
import { config, processActivitiesData, processPagesData } from './config/config';
import { positionsConfig } from './config/positionsConfig';
import { pagesConfig } from './config/pagesConfig';
import { Activity } from './components/declarations/Activity';
import { playSfx } from './helpers/sounds';

// console.log('env', process.env.NODE_ENV);
// console.log('config', config);
// console.log('Action uuids', actionUuids);
// console.log('iframePlayerHash', iframePlayerHash);
// console.log('DEBUG MODE', config.DEBUG);
// console.log('features', getFeatures());

let scene: Scene;
let voiceover: Howl;

const enterCard: HTMLDivElement = <HTMLDivElement>document.querySelector('.enter');
const enterButton: HTMLButtonElement = <HTMLButtonElement>document.querySelector('.enter-button');
const enterButtonText: HTMLButtonElement = <HTMLButtonElement>document.querySelector('.enter-button-text');
const soundImage: SVGElement = <SVGElement>document.querySelector('.sound-image');
const flipper: HTMLDivElement = <HTMLDivElement>document.querySelector('.flipper');
const preloader = new Preloader();

initResize();
loadAssets();

let clickCounter = 0;

async function loadAssets() {
  const activities = await Assets.load(`${config.DATA_PATH}activities.json`);
  const images = [];
  images.push({ alias: 'main_sheet', src: `${config.SPRITES_PATH}st-items.json` });
  images.push({ alias: 'st-objects', src: `${config.SPRITES_PATH}st-objects.json` });
  images.push({ alias: 'st-extra', src: `${config.SPRITES_PATH}st-extra.json` });

  positionsConfig.forEach((layerData) => {
    if (layerData.bg && layerData.bg.length > 0) {
      layerData.bg.forEach((imageInfo) => {
        images.push({ alias: imageInfo.id, src: `${config.IMAGES_PATH}main/layers/${imageInfo.id}.png` });
      });
    }
  });

  Assets.addBundle('images', images);
  await Assets.loadBundle('images', (progress) => {
    preloader.updateLoader(progress);
  });

  WebFont.load({
    google: {
      families: ['Grandstander', 'Noto Sans'],
      text: 'ěšřčžýáíéĚŠČŘŽÝÁÍÉQWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnmúůÚŮ/1234567890,.:',
    },
    active: () => {
      onAssetsLoaded(activities);
    },
  });
}

function onAssetsLoaded(activities: Activity[]) {
  processActivitiesData(activities, isMobileOrTablet, isAndroid, isIOS);
  processPagesData(pagesConfig);

  preloader.hide();

  scene = new Scene();

  enterCard.addEventListener('pointerup', onEnterClicked);
  flipper.classList.remove('out-of-view');
}

function onEnterClicked(evt: Event) {
  evt.preventDefault();
  clickCounter++;

  if (clickCounter === 1) {
    flipper.classList.add('flipped');
    voiceover = playSfx('vo_intro');
    enterButtonText.innerText = 'PŘESKOČIT';
    enterButton.classList.remove('hide-svg');
    soundImage.style.display = 'none';
    voiceover.on('end', () => onEnterClicked(evt));
  } else if (clickCounter >= 1) {
    voiceover.stop();
    enterCard.style.display = 'none';
    document.getElementById('app-body')?.classList.remove('hide-buttons');
    scene.start();
  }
}
